
import CSearchList from '@/components/c-search-list'
import CTable from '@/components/c-table'
import { getIndexConfig, getTableConfig, inputList } from './config'
import { defineComponent, reactive, toRefs, onMounted } from 'vue'
import { dropdownOfEnterprise, getList } from './api'
import { toResult } from '@/utils/toResult'
import { usePagination } from '@/hooks/usePagination'

export default defineComponent({
  name: 'unit-conversation', // 单位会话
  components: {
    CSearchList,
    CTable
  },
  setup() {
    // 企业名称远程搜索
    const remoteData1 = reactive({
      options: [] as any[],
      isLoading: false,
      remoteMethod: (val: string) => {
        dropdownOfEnterprise({ value: val }).then((res: any) => {
          remoteData1.options = (res.data || []).map((item: any) => {
            return {
              label: item.value,
              value: item.key
            }
          })
        })
      }
    })

    const data = reactive({
      inputList: inputList({ ...toRefs(remoteData1) }),
      ...getIndexConfig()
    })

    const tableConfig = reactive({
      ...getTableConfig()
    })

    const getListFn = async () => {
      const p = {
        ...data.queryForm,
        currPage: tableConfig.pagination.currentPage,
        pageSize: tableConfig.pagination.pageSize
      }

      tableConfig.loading = true
      const [err, res] = await toResult(getList(p))
      tableConfig.loading = false
      if (err) return
      tableConfig.data = res.list || []
      tableConfig.pagination.total = res.total
    }

    // 查询
    const handleSearch = (params: object) => {
      tableConfig.pagination.currentPage = 1
      params && (data.queryForm = { ...params })
      getListFn()
    }

    // 重置
    const handleReset = (val: object) => {
      data.queryForm = val
    }

    const { pageCurrentChange, pageSizeChange } = usePagination(
      tableConfig.pagination,
      () => {
        getListFn()
      }
    )

    onMounted(() => {
      handleSearch({})
    })

    return {
      ...toRefs(data),
      handleSearch,
      handleReset,
      tableConfig,
      pageCurrentChange,
      pageSizeChange,
      getListFn
    }
  }
})
